import { THttpService } from '@/services/HttpService';

import { TVoucherItem } from './types';
import * as service from './service';

export const getVoucherListResponse = async (api: THttpService) => {
  const result = await service.voucherList(api);
  result.voucherMemberList = result.voucherMemberList
    .sort((a: TVoucherItem, b: TVoucherItem) => b.discount - a.discount)
    .filter((item: TVoucherItem) => {
      const expireDate = new Date(item.expiration);
      const nowDate = new Date();
      const isExpired = expireDate < nowDate;
      const reusableAvailableMiles =
        item.totalUsed === 0 ||
        (item.quantity > item.totalUsed && item.reusable);
      return item.voucherNumber && !isExpired && reusableAvailableMiles;
    });

  return result;
};

export const filterMilesPurchaseVouchers = (voucherList: TVoucherItem[]) => {
  return voucherList.filter(
    voucher =>
      voucher.type === 'MILEPURCHASE' || voucher.type === 'MILESBENEFIT',
  );
};

export const filterAirlineVouchers = (voucherList: TVoucherItem[]) => {
  return voucherList.filter(voucher => voucher.type === 'AIRLINE');
};
